import { z } from "zod/v4";

import { ProductVariantEventStatusList } from "../schemas/products";
import { castToString } from "../utils";

import { OfferProductInclusionTypeList } from "./offer-products";
import { VariationDtoSchema } from "./variations";

export const ProductVariantProductTypeList = [
  "analytics",
  "price",
  "offer",
] as const;

export type ProductVariantProductType =
  (typeof ProductVariantProductTypeList)[number];

export const ProductVariantDtoSchema = z.object({
  id: z.uuid(),
  productId: z.string(),
  variantId: z.string(),
  productTitle: z.string(),
  variantTitle: z.string(),
  experienceId: z.uuid(),
  variationId: z.uuid(),
  offerId: z.uuid().nullish(),
  price: castToString.nullish(),
  compareAtPrice: castToString.nullish(),
  subscriptionDiscount: z.string().nullish(),
  subscriptionDiscountType: z.string().nullish(),
  handle: z.string().nullish(),
  dupProductId: z.string().nullish(),
  dupVariantId: z.string().nullish(),
  dupHandle: z.string().nullish(),
  variation: VariationDtoSchema,
  isDeleted: z.boolean().nullish(),
  eventStatus: z.enum(ProductVariantEventStatusList).nullish(),
  inclusionType: z.enum(OfferProductInclusionTypeList),
  type: z.enum(ProductVariantProductTypeList),
});

export type ProductVariantDto = z.infer<typeof ProductVariantDtoSchema>;

export const ProductVariantWithDeletedDtoSchema =
  ProductVariantDtoSchema.extend({
    variation: VariationDtoSchema.nullish(),
  });

export type ProductVariantWithDeletedDto = z.infer<
  typeof ProductVariantWithDeletedDtoSchema
>;

export const CreateProductVariantDtoSchema = ProductVariantDtoSchema.omit({
  variation: true,
});
export type CreateProductVariantDto = z.infer<
  typeof CreateProductVariantDtoSchema
>;

export const RedactedProductVariantForPutProductVariantsFromS3DtoSchema =
  z.object({
    id: z.uuid(),
    productId: z.string(),
    variantId: z.string(),
    productTitle: z.string(),
    price: castToString.nullish(),
    compareAtPrice: castToString.nullish(),
    subscriptionDiscount: z.string().nullish(),
    subscriptionDiscountType: z.string().nullish(),
    handle: z.string().nullish(),
    dupProductId: z.string().nullish(),
    dupVariantId: z.string().nullish(),
    variation: z.object({
      id: z.uuid(),
      name: z.string(),
      isControl: z.boolean(),
    }),
  });

export type RedactedProductVariantForPutProductVariantsFromS3Dto = z.infer<
  typeof RedactedProductVariantForPutProductVariantsFromS3DtoSchema
>;
